const dbVersion = 1;
const dbName = "imageDatabase";
const storeName = "images";

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, dbVersion);

    request.onerror = (event) => {
      console.error("IndexedDB error:", request.error);
      reject(request.error);
    };

    request.onsuccess = (event) => {
      resolve(request.result);
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: "type" });
      }
    };
  });
}

async function dbUploadImage(type, images) {
  const db = await openDB();

  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);

    // Load existing data within the same transaction
    const request = objectStore.get(type);

    request.onsuccess = async () => {
      const existingData = request.result ? request.result.images : [];
      const updatedImages = [...existingData, ...images];

      // Update the store with the new data
      const putRequest = objectStore.put({ type, images: updatedImages });

      putRequest.onsuccess = () => resolve();
      putRequest.onerror = (event) => reject(putRequest.error);
    };

    request.onerror = (event) => reject(request.error);
  });
}

async function dbLoadImages(type) {
  const db = await openDB();
  const transaction = db.transaction([storeName], "readonly");
  const objectStore = transaction.objectStore(storeName);

  const request = objectStore.get(type);

  return new Promise((resolve, reject) => {
    request.onsuccess = () => {
      const result = request.result;
      resolve(result ? result.images : []);
    };
    request.onerror = (event) => reject(request.error);
  });
}
async function dbDeleteAllImages(type) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);

    // Ensure the type (key) is provided
    if (!type) {
      reject(new Error("No key specified for deletion"));
      return;
    }

    // Delete the record with the specified key
    const request = objectStore.delete(type);

    request.onsuccess = () => resolve();
    request.onerror = (event) => reject(request.error);
  });
}
async function dbDeleteImage(type, index) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);

    // Load existing data within the same transaction
    const request = objectStore.get(type);

    request.onsuccess = () => {
      const existingData = request.result ? request.result.images : [];

      if (!existingData || existingData.length <= index) {
        reject(new Error("Image not found for deletion"));
        return;
      }

      // Remove the image at the specified index
      const updatedImages = existingData.filter((_, i) => i !== index);

      // Update the store with the modified data
      const putRequest = objectStore.put({ type, images: updatedImages });

      putRequest.onsuccess = () => resolve();
      putRequest.onerror = (event) => reject(putRequest.error);
    };

    request.onerror = (event) => reject(request.error);
  });
}
async function dbEditImageText(type, index, newText) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);

    // Load existing data within the same transaction
    const request = objectStore.get(type);

    request.onsuccess = () => {
      const existingData = request.result ? request.result.images : [];

      if (!existingData || existingData.length <= index) {
        reject(new Error("Image not found for editing"));
        return;
      }

      // Update the text of the image at the specified index
      existingData[index].text = newText;

      // Update the store with the modified data
      const putRequest = objectStore.put({ type, images: existingData });

      putRequest.onsuccess = () => resolve();
      putRequest.onerror = (event) => reject(putRequest.error);
    };

    request.onerror = (event) => reject(request.error);
  });
}
async function saveColorAtIndex(type, index, colorValue) {
  const db = await openDB(); // your function to open IndexedDB

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);

    const request = objectStore.get(type);

    request.onsuccess = () => {
      // Use existing array or initialize
      const existingData = request.result ? request.result.images : [];

      if (!existingData || existingData.length <= index) {
        reject(new Error("Image not found for editing count"));
        return;
      }
      existingData[index].color = colorValue;
      const putRequest = objectStore.put({ type, images: existingData });
      putRequest.onsuccess = () => resolve();
      putRequest.onerror = () => reject(putRequest.error);
    };

    request.onerror = () => reject(request.error);
  });
}

async function editImageCount(type, index, newCount) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);

    // Load existing data within the same transaction
    const request = objectStore.get(type);

    request.onsuccess = () => {
      const existingData = request.result ? request.result.images : [];

      if (!existingData || existingData.length <= index) {
        reject(new Error("Image not found for editing count"));
        return;
      }

      // Update the count of the image at the specified index
      existingData[index].count = newCount;

      // Update the store with the modified data
      const putRequest = objectStore.put({ type, images: existingData });

      putRequest.onsuccess = () => resolve();
      putRequest.onerror = (event) => reject(putRequest.error);
    };

    request.onerror = (event) => reject(request.error);
  });
}

async function dbADDImageSrcRm(type, index, srcRm) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);

    // Load existing data within the same transaction
    const request = objectStore.get(type);

    request.onsuccess = () => {
      const existingData = request.result ? request.result.images : [];

      if (!existingData || existingData.length <= index) {
        reject(new Error("Image not found for editing count"));
        return;
      }

      // Update the count of the image at the specified index
      existingData[index].srcRm = srcRm;

      // Update the store with the modified data
      const putRequest = objectStore.put({ type, images: existingData });

      putRequest.onsuccess = () => resolve();
      putRequest.onerror = (event) => reject(putRequest.error);
    };

    request.onerror = (event) => reject(request.error);
  });
}

async function dbADDImageBg(type, index, Bg) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);
    const request = objectStore.get(type);
    request.onsuccess = () => {
      const existingData = request.result ? request.result.images : [];
      if (!existingData || existingData.length <= index) {
        reject(new Error("Image not found for editing count"));
        return;
      }

      // Update the count of the image at the specified index
      existingData[index].Bg = Bg;

      // Update the store with the modified data
      const putRequest = objectStore.put({ type, images: existingData });

      putRequest.onsuccess = () => resolve();
      putRequest.onerror = (event) => reject(putRequest.error);
    };

    request.onerror = (event) => reject(request.error);
  });
}

  async function saveDocumentTypeAtIndex(type, index, documentType) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([storeName], "readwrite");
      const objectStore = transaction.objectStore(storeName);
      const request = objectStore.get(type);
      request.onsuccess = () => {
        const existingData = request.result ? request.result.images : [];
        if (!existingData || existingData.length <= index) {
          reject(new Error("Image not found for editing document type"));
          return;
        }
        existingData[index].documentType = documentType;
        const putRequest = objectStore.put({ type, images: existingData });
        putRequest.onsuccess = () => resolve();
        putRequest.onerror = () => reject(putRequest.error);
      };
      request.onerror = () => reject(request.error);
    });
  }
export {
  dbADDImageBg,
  dbADDImageSrcRm,
  saveColorAtIndex,
  editImageCount,
  dbEditImageText,
  dbDeleteImage,
  dbDeleteAllImages,
  dbUploadImage,
  dbLoadImages,
  saveDocumentTypeAtIndex
};
